export default __webpack_public_path__ + "static/media/Pablita-Social-Network.384f020a.png";